import * as React from "react"
import { observer } from "mobx-react"
import AppStateStore from "../stores/AppStateStore"

@observer
export default class ContentHeader extends React.Component {
  render (): React.ReactNode {
    return AppStateStore.renderContentHeader()
  }
}